<template>
  <j-modal :title="title" :width="462" :visible="visible" :footer="null" @cancel="handleCancel">
    <div class="product-detail-root">
      <!-- Swiper -->
      <div class="product-swiper">
        <img v-if="images && images.length > 0 " width="100%" height="316"
             :src="images[0]" />
      </div>
      <!-- Swiper -->
      <div class="product-content">
        <div class="product-tags">
          <span class="product-tag" v-for="i in tags" :key="i">{{ i }}</span>
        </div>
        <div class="product-name">
          {{ record.name }}
        </div>
        <div class="product-shop">
          {{ record.supplierName }}
        </div>
        <div class="product-field">
          <div class="product-price">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16"
              size="16" color="#D5A85F" data-v-5d0cdcb4="">
              <g id="ic-honhaimoney-red" transform="translate(0 0.296)">
                <path id="Subtraction_9" data-name="Subtraction 9"
                  d="M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-1.508-7.333h3.015v3.333h1.993v-8h-1.993v3.179h-3.015V2090.7h-1.992v8h1.992v-3.333Z"
                  transform="translate(2502 -2087)"></path>
              </g>
            </svg>
            {{ record.price }}
          </div>
          <div class="product-stock">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16"
              size="16" color="#0c52a7" data-v-27567401="">
              <g id="ic-honhaimoney" transform="translate(0 0.296)">
                <path id="Subtraction_9" data-name="Subtraction 9"
                  d="M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-4.1-9.448h0v3.394a.913.913,0,0,0,.456.788l2.958,1.691v-3.9l-3.415-1.975Zm8.194,0h0l-3.413,1.975v3.9l2.957-1.691a.914.914,0,0,0,.456-.788v-3.394Zm-4.1-2.975a.912.912,0,0,0-.455.121l-2.942,1.681,3.4,1.965,3.4-1.965-2.943-1.681A.914.914,0,0,0-2494,2090.281Z"
                  transform="translate(2502 -2087)"></path>
              </g>
            </svg>
            {{ record.virtual == 0 ? '尚餘數量 1000組' : '捐助總額 1000元' }}
          </div>
        </div>
        <div class="product-driver"></div>
        <div class="product-introduce">
<!--          <h5 class="product-introduce-title">{{ record.virtual == 0 ? '產品介紹' : '商家故事' }}</h5>-->
          <h5 class="product-introduce-title">{{'產品介紹'}}</h5>
          <p class="product-introduce-text" v-if="record.description" v-html="record.description || '--'" />
<!--          <p class="product-introduce-text" v-if="record.story"  v-html="record.story || '&#45;&#45;'" />-->
          <dl class="product-introduce-attr" v-if="record.virtual == 0">
            <dt class="product-attr-label">內容物重量(g)</dt>
            <dd class="product-attr-value" v-html="record.weight || '--'" />
          </dl>
          <dl class="product-introduce-attr" v-if="record.virtual == 0">
            <dt class="product-attr-label">外盒尺寸長*寬*高 (cm)</dt>
            <dd class="product-attr-value" v-html="`${record.length || '--'}*${record.width || '--'}*${record.height || '--'}`"></dd>
          </dl>
          <dl class="product-introduce-attr" v-if="record.virtual == 0">
            <dt class="product-attr-label">有效日期</dt>
            <dd class="product-attr-value" v-html="record.validityPeriod || '--'" />
          </dl>
          <dl class="product-introduce-attr" v-if="record.virtual == 0">
            <dt class="product-attr-label">成分</dt>
            <dd class="product-attr-value" v-html="record.ingredient || '--'" />
          </dl>
          <dl class="product-introduce-attr" v-if="record.virtual == 0">
            <dt class="product-attr-label">產地</dt>
            <dd class="product-attr-value" v-html="record.origin || '--'" />
          </dl>
          <!-- <dl class="product-introduce-attr" v-if="record.virtual == 0">
            <dt class="product-attr-label">保存方式</dt>
            <dd class="product-attr-value" v-html="record.storage || '&#45;&#45;'" />
          </dl> -->
          <a class="product-introduce-link" v-if="record.virtual != 0">
            我想以點數捐助此商家
            <svg id="icon-24-calendar-right" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="24" viewBox="0 0 24 24" class="ml-1"><rect id="Rectangle_9137" data-name="Rectangle 9137" width="24" height="24" fill="rgba(255,255,255,0.01)"></rect><path id="Union_399" data-name="Union 399" d="M-5519.707-108.293a1,1,0,0,1,0-1.415l4.293-4.293H-5531a1,1,0,0,1-1-1,1,1,0,0,1,1-1h15.587l-4.293-4.294a1,1,0,0,1,0-1.413,1,1,0,0,1,1.414,0l6,6a1,1,0,0,1,.2.295l0,.005.006.014.006.015v0A1,1,0,0,1-5512-115a1,1,0,0,1-.3.714l-5.993,5.993A1,1,0,0,1-5519-108,1,1,0,0,1-5519.707-108.293Z" transform="translate(5534.101 127)" fill="#ef7555"></path></svg>
          </a>
        </div>
      </div>
    </div>
  </j-modal>
</template>

<script>
export default {
  name: 'PreviewProductModal',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
    },
    record: {
      type: Object,
    },
    tags: {
      type: Array,
    },
    images: {
      type: Array,
    },
  },
  mounted: () => {

  },
  data() {
    return {
      title: '商品预览',
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>

<style scoped lang="less">
.product-detail-root {
  background: #F5F5F5 0% 0% no-repeat padding-box;
  width: 100%;
  max-height: 896px;
  overflow-y: auto;
  border: 1px solid var(--gray-80);

  &::-webkit-scrollbar {
    max-width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #EF7843;
  }

  &::-webkit-scrollbar-track {
    border-radius: 4px;
    background: #ededed;
  }

  .product-swiper {
    width: 100%;
  }

  .goods-swipper{
    height: 316px;
    max-height: 316px;
    .van-swipe-item{
      position: relative;
      overflow: hidden;
      margin: auto;
      text-align: center;
      background-position: center;
      background-size: cover;
      background-origin: content-box;
      background-repeat: no-repeat;
      img{
        width: 100%;
      }
    }
    .custom-indicator{
      position: absolute;
      right: 16px;
      bottom: 8px;
      padding: 0px 11px;
      /* UI Properties */
      background: var(--gray-100) 0% 0% no-repeat padding-box;
      box-shadow: 0px 0px 10px #00000026;
      border-radius: 9px;
      /* UI Properties */
      font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-12)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-noto-sans);
      letter-spacing: var(--unnamed-character-spacing-0);
      color: var(--unnamed-color-ffffff);
      text-align: center;
    }
  }

  .product-content {
    padding: 20px;

    .product-tags {
      margin-bottom: 8px;

      .product-tag {
        margin-right: 8px;
        padding: 3px 8px;
        text-align: center;
        font: normal normal normal 12px/12px Noto Sans;
        letter-spacing: 0px;
        color: #EF7843;
        border: 1px solid #EF8455;
        border-radius: 4px;
      }
    }

    .product-name {
      margin-bottom: 4px;
      text-align: left;
      font: normal normal bold 18px/27px Noto Sans;
      letter-spacing: 0.32px;
      color: #2F2F2F;
    }

    .product-shop {
      margin-bottom: 8px;
      text-align: left;
      font: normal normal bold 14px/21px Noto Sans;
      letter-spacing: 0px;
      color: #676767;
    }

    .product-field {
      display: flex;
      text-align: left;

      svg {
        margin-right: 4px;
      }

      .product-price {
        display: flex;
        align-items: center;
        font: normal normal bold 14px/21px Noto Sans;
        letter-spacing: 0px;
        color: #D5A85F;
        margin-right: 12px;
      }

      .product-stock {
        display: flex;
        align-items: center;
        text-align: left;
        font: normal normal normal 14px/24px Noto Sans;
        letter-spacing: 0px;
        color: #2F2F2F;
      }
    }

    .product-driver {
      height: 1px;
      margin: 24px auto;
      background: #EDEDED 0% 0% no-repeat padding-box;
    }

    .product-introduce {
      &-title {
        margin-bottom: 4px;
        text-align: left;
        font: normal normal bold 16px/24px Noto Sans;
        letter-spacing: 0.26px;
        color: #2F2F2F;
      }

      &-text {
        text-align: left;
        font: normal normal normal 14px/24px Noto Sans;
        letter-spacing: 0px;
        color: #2F2F2F;
        opacity: 1;
      }

      &-attr{
        margin-bottom: 24px;
        .product-attr-label{
          text-align: left;
          font: normal normal bold 16px/24px Noto Sans;
          letter-spacing: 0.26px;
          color: #2F2F2F;
          margin-bottom: 4px;
        }
        .product-attr-value{
          text-align: left;
          font: normal normal normal 14px/24px Noto Sans;
          letter-spacing: 0px;
          color: #2F2F2F;
        }
      }

      &-link{
        display: flex;
        text-align: right;
        font: normal normal bold 14px/21px Noto Sans;
        letter-spacing: 0px;
        color: #EF7555;
      }
    }
  }
}
</style>